"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;

var _styledComponents = require("styled-components");

var _utils = require("../../../utils");

var _placeholder = require("./placeholder.inject");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    cursor: wait;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0) 33%, var(--c-light) 66%, rgba(255, 255, 255, 0));\n    background-size: 1200px 100%;\n\n    animation: ", " 2s linear infinite;\n\n    ", ";\n\n    ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    background-position: -1200px 0;\n  }\n\n  to {\n    background-position: 1200px 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var shimmer = (0, _styledComponents.keyframes)(_templateObject());
var Placeholder = (0, _utils.sc)('div')(function (_ref) {
  var variant = _ref.variant,
      appearance = _ref.appearance;
  return (0, _styledComponents.css)(_templateObject2(), shimmer, _placeholder.inject.borderRadius(appearance === null || appearance === void 0 ? void 0 : appearance.borderRadius), _placeholder.inject.getVariant({
    variant: variant,
    appearance: appearance
  }));
})('Placeholder');
var Styled = {
  Placeholder: Placeholder
};
exports.Styled = Styled;